/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsScheduleDayDtoSchema = z.object({
  date: z.string().nullish(),
  time: z.string().nullish(),
  stageType: z.string().nullish(),
});
